/** Búsqueda AND: 2–4 palabras deben coincidir todas (Fase 2 · Presupuestos/Ventas). */

export function tokenizeSearch(query: string, maxTokens = 4): string[] {
  return String(query || "")
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, maxTokens);
}

export function matchesAllWords(haystack: string, query: string): boolean {
  const tokens = tokenizeSearch(query);
  if (tokens.length === 0) return true;
  const h = String(haystack || "").toLowerCase();
  return tokens.every((t) => h.includes(t));
}

export type PresupuestoListadoSearchRow = {
  numero?: string | null;
  estado?: string | null;
  cliente?: {
    nombre?: string | null;
    codigo?: string | null;
    cuit?: string | null;
    dni?: string | null;
  } | null;
};

/** Campos del listado de presupuestos que entran en la búsqueda AND. */
export function presupuestoListadoHaystack(p: PresupuestoListadoSearchRow): string {
  return [
    p.numero,
    p.cliente?.nombre,
    p.cliente?.codigo,
    p.cliente?.cuit,
    p.cliente?.dni,
    p.estado,
  ]
    .filter(Boolean)
    .join(" ");
}

export function filterPresupuestosListado<T extends PresupuestoListadoSearchRow>(
  presupuestos: T[],
  searchQuery: string,
): T[] {
  return presupuestos.filter((p) => matchesAllWords(presupuestoListadoHaystack(p), searchQuery));
}
